import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon, MenuIcon, Trash2Icon, ImagesIcon, ListOrderedIcon, ShieldCheckIcon, StarIcon, MapPinIcon, PhoneIcon, BoxIcon } from "lucide-react";
interface NavItem {
  id: string;
  label: string;
  icon: BoxIcon;
}
const navItems: NavItem[] = [{
  id: 'what-we-remove',
  label: 'What we remove',
  icon: Trash2Icon
}, {
  id: 'before-after',
  label: 'Before & after',
  icon: ImagesIcon
}, {
  id: 'how-it-works',
  label: 'How it works',
  icon: ListOrderedIcon
}, {
  id: 'why-us',
  label: 'Why Javier\u2019s',
  icon: ShieldCheckIcon
}, {
  id: 'reviews',
  label: 'Reviews',
  icon: StarIcon
}, {
  id: 'service-areas',
  label: 'Service areas',
  icon: MapPinIcon
}, {
  id: 'guarantee',
  label: 'Our guarantee',
  icon: ShieldCheckIcon
}, {
  id: 'contact',
  label: 'Call us',
  icon: PhoneIcon
}];
export function NavAccordion() {
  const [open, setOpen] = useState(false);
  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    setOpen(false);
  };
  return <div className="border-t border-white/10" data-id="element-171" data-mp="2qappc76hai97">
      <button type="button" onClick={() => setOpen(current => !current)} aria-expanded={open} aria-controls="site-nav-panel" className="mx-auto flex w-full max-w-6xl items-center justify-between gap-3 px-5 py-2.5 text-left transition-colors duration-150 ease-out hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ember-500" data-id="element-172" data-mp="2lcxy7fdnr062">
        <span className="flex items-center gap-2 font-display text-sm uppercase tracking-[0.16em] text-white" data-id="element-173" data-mp="393k34xsd84bu">
          <MenuIcon className="h-4 w-4 text-ember-500" aria-hidden="true" data-id="element-174" data-mp="349z0gsftum6b" />
          Browse the site
        </span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-white transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-175" data-mp="myph3osgn2e" />
      </button>

      <AnimatePresence initial={false} data-id="element-176" data-mp="3s0bjozgiw5c7">
        {open && <motion.nav id="site-nav-panel" aria-label="Site sections" initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden bg-forest-900" data-id="element-177" data-mp="1q3kktdo1wzph">
            <ul className="mx-auto grid max-w-6xl grid-cols-2 gap-2 px-5 py-4 sm:grid-cols-4" data-id="element-178" data-mp="1lb162ddmnyj3">
              {navItems.map(({
            id,
            label,
            icon: Icon
          }) => <li key={id} data-id="element-179" data-mp="1bd3izt7i87s2">
                  <button type="button" onClick={() => goTo(id)} className="flex w-full items-center gap-2 rounded-md bg-white/5 px-3 py-2.5 text-left text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-ember-500" data-id="element-180" data-mp="xfooia2e99t8">
                    <Icon className="h-4 w-4 shrink-0 text-ember-500" aria-hidden="true" data-id="element-181" data-mp="2wssrmd63nz08" />
                    {label}
                  </button>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </div>;
}